import * as ActionTypes from 'state/actions/types'

export const resolvedByBotChangeField = (field, value) => {
  return {
    type: ActionTypes.RESOLVED_BY_BOT_CHANGE_FIELD,
    field,
    value
  }
}

export const resolvedByBotChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.RESOLVED_BY_BOT_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const resolvedByBotMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.RESOLVED_BY_BOT_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
